type StructurePathSegment = string | number;
export type StructurePath = readonly StructurePathSegment[];

export function appendStructurePath(
    path: StructurePath,
    segment: StructurePathSegment
): StructurePath {
    return [...path, segment];
}

export function formatStructurePath(path: StructurePath): string {
    if (!path.length) {
        return '<root>';
    }

    return path.reduce<string>((result, segment) => {
        if (typeof segment === 'number') {
            return `${result}[${segment}]`;
        }

        if (!result.length) {
            return segment;
        }

        return `${result}.${segment}`;
    }, '');
}
